import { render, staticRenderFns } from "./TouchpointStatisticsInfoHeader.vue?vue&type=template&id=53725954&scoped=true&"
import script from "./TouchpointStatisticsInfoHeader.vue?vue&type=script&lang=js&"
export * from "./TouchpointStatisticsInfoHeader.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointStatisticsInfoHeader.vue?vue&type=style&index=0&id=53725954&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53725954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53725954')) {
      api.createRecord('53725954', component.options)
    } else {
      api.reload('53725954', component.options)
    }
    module.hot.accept("./TouchpointStatisticsInfoHeader.vue?vue&type=template&id=53725954&scoped=true&", function () {
      api.rerender('53725954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/Statistics/TouchpointStatisticsInfoHeader.vue"
export default component.exports